import comp from "./SelectEditTemplate";
export default comp;
